<div class="dialog_main">
  <button type="button" class="dialog_close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'Readytoengage' | translate }}</h2>
      <p>{{ 'Listyourexceptionalexperiences' | translate }}</p>
    </div>

    <form [formGroup]="memberFormGroup" (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <div class="form_group text_center typeInput">
          <mat-label class="ll">
            {{ 'Uploadyourcompanylogo' | translate }}
          </mat-label>
          <label class="upload_box v2">
            @if (memberFormGroup.get('image')?.value) {
              <div class="preview">
                <figure>
                  <img [src]="memberFormGroup.get('image')?.value" alt="" />
                </figure>
              </div>
            } @else {
              <mat-icon>add</mat-icon>
            }
            <input
              accept="image/*"
              type="file"
              class="form_control prpty_mg"
              (change)="onFileChange($event)" />
          </label>
        </div>

        <div class="form_group">
          <mat-label class="required">{{
            'CompanyName' | translate
          }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              [placeholder]="'enteryourCompanyName' | translate"
              class="form_control"
              formControlName="businessName" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="businessNameValidator">
          </ng-container>
        </div>

        <div class="form_group">
          <mat-label class="required mb_0"
            >{{ 'Address' | translate }}

            </mat-label
          >
          <span class="note" >
            {{ 'Notetheaddresswillauto' | translate }}
          </span>
          <mat-form-field appearance="fill">
            <input
              #place1
              matInput
           
              [placeholder]="'Addyourcompanyaddress' | translate"
              class="form_control"
              formControlName="address" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="addressValidator"> </ng-container>
        </div>
        <div class="flex-div">
          <div class="form_group">
            <mat-label class="required">{{ 'City' | translate }}</mat-label>
            <mat-form-field appearance="fill">
              <input
                
                matInput
                [placeholder]="'city' | translate"
                formControlName="city"
                class="form_control" />
            </mat-form-field>
            <ng-container *ngTemplateOutlet="cityValidator"> </ng-container>
          </div>

          <div class="form_group">
            <mat-label>{{'ZipCode' | translate}}</mat-label>
            <mat-form-field appearance="fill">
              <input
                
                type="number"
                matInput
                [placeholder]="'ZipCode' | translate"
                class="form_control"
                formControlName="pinCode" />
            </mat-form-field>
            <ng-container *ngTemplateOutlet="pinCodeValidator"> </ng-container>
          </div>
        </div>

        <div class="form_group">
          <mat-label class="required">{{'FullName' | translate}}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              [placeholder]="'fullName' | translate"
              formControlName="name"
              class="form_control" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="fullNameValidator"> </ng-container>
        </div>

        <div class="form_group">
          <mat-label class="required">{{'Email' | translate}}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              [placeholder]="'EmailAddress' | translate"
              class="form_control"
              formControlName="email" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="emailValidator"> </ng-container>
        </div>

        <div class="form_group">
          <mat-label class="required">{{'PhoneNo' | translate}}.</mat-label>

          <ngx-mat-intl-tel-input
            [preferredCountries]="['ae', 'in']"
            [enableSearch]="true"
            [enablePlaceholder]="true"
            (countryChanged)="onCountryChanged($event)"
            formControlName="phoneNo"
            class="phone_selector phone_select_top">
          </ngx-mat-intl-tel-input>
          <ng-container *ngTemplateOutlet="phoneNumberValidator">
          </ng-container>
        </div>
        <div class="flex-div">
          <div class="form_group">
            <mat-label>{{'CompanyWebsite' | translate}}</mat-label>
            <mat-form-field appearance="fill">
              <input
                matInput
                [placeholder]="'CompanyWebsite' | translate"
                class="form_control"
                formControlName="companyWebsite" />
            </mat-form-field>
          </div>

          <div class="form_group">
            <mat-label class="required"> {{'TypeOfBusiness' | translate}}</mat-label>
            <mat-form-field appearance="fill">
              <input
                matInput
                [placeholder]="'TypeofBusiness' | translate"
                class="form_control"
                formControlName="typeOfBusiness" />
            </mat-form-field>
            <ng-container *ngTemplateOutlet="typeofBusinessValidator">
            </ng-container>
          </div>
        </div>
      </div>

      <div class="form_btn">
        <button type="submit" class="btn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>

<ng-template #ImageValidator>
  @if (submitted && memberFormGroup.controls['image'].hasError('required')) {
    <mat-error>
      {{ 'BusinessPhoto' | translate }}
      {{ 'IsRequired' | translate }}
    </mat-error>
  }
</ng-template>

<ng-template #businessNameValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['businessName'].hasError('required')) {
      <mat-error>
        {{ 'CompanyName' | translate }}
        {{ 'IsRequired' | translate }}
      </mat-error>
    }
    @if (memberFormGroup.controls['businessName'].hasError('pattern')) {
      <mat-error>{{ 'validBusinessName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['businessName'].hasError('minLength')) {
      <mat-error>{{ 'minLengthBusinessName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['businessName'].hasError('maxLength')) {
      <mat-error>{{ 'maxLengthBusinessName' | translate }}</mat-error>
    }
  }
</ng-template>

<ng-template #fullNameValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['name'].hasError('required')) {
      <mat-error>
        {{ 'fullName' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
    @if (memberFormGroup.controls['name'].hasError('pattern')) {
      <mat-error>{{ 'validFullName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['name'].hasError('minLength')) {
      <mat-error>{{ 'minLengthFullName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['name'].hasError('maxLength')) {
      <mat-error>{{ 'maxLengthFullName' | translate }}</mat-error>
    }
  }
</ng-template>

<ng-template #addressValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['address'].hasError('required')) {
      <mat-error>
        {{ 'Address' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>

<ng-template #cityValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['city'].hasError('required')) {
      <mat-error>
        {{ 'city' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>

<ng-template #pinCodeValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['pinCode'].hasError('maxlength')) {
      <mat-error>{{ 'maxLengthPinCode' | translate }}</mat-error>
    }
  }
</ng-template>

<ng-template #emailValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['email'].hasError('required')) {
      <mat-error>{{ 'emailRequired' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['email'].hasError('pattern')) {
      <mat-error>{{ 'enterEmailValid' | translate }}</mat-error>
    }
  }
</ng-template>

<ng-template #phoneNumberValidator>
  @if (submitted) {
    @if (
      (memberFormGroup.get('phoneNo')?.value === '' ||
        memberFormGroup.get('phoneNo')?.value === null) &&
      memberFormGroup.get('phoneNo')?.hasError('required')
    ) {
      <mat-error>
        {{ 'PhoneNumber' | translate }}
        {{ 'IsRequired' | translate }}
      </mat-error>
    }
    @if (
      memberFormGroup.get('phoneNo')?.value === undefined ||
      memberFormGroup.get('phoneNo')?.hasError('validatePhoneNumber')
    ) {
      <mat-error>
        {{ 'PleaseEnterValidPhone' | translate }}
      </mat-error>
    }
  }
</ng-template>

<ng-template #typeofBusinessValidator>
  @if (submitted) {
    @if (memberFormGroup.get('typeOfBusiness')?.hasError('required')) {
      <mat-error>
        {{ 'TypeofBusiness' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>
